module.exports = __webpack_public_path__ + "img/rule_3.9ed9729c.png";